import React from 'react';
import { ColorTheme } from '../types';

export const ColorThemeContext = React.createContext<ColorTheme>({
  colorTheme: 'light',
});
export const ColorThemeProvider = ColorThemeContext.Provider;
